import React, { useState } from 'react';
import { WellbeingData } from '../../../types/wellbeing';
import { FoodIcon } from '../CategoryIcons';

interface FoodModalProps {
  data: WellbeingData;
  onSave: (data: Partial<WellbeingData>) => void;
  onClose: () => void;
}

export const FoodModal: React.FC<FoodModalProps> = ({ data, onSave, onClose }) => {
  const [localData, setLocalData] = useState({
    dietChange: data.dietChange ?? false,
    dietChangeNote: data.dietChangeNote ?? '',
    mealHeaviness: data.mealHeaviness ?? 0,
    alcohol: data.alcohol ?? false,
    alcoholNote: data.alcoholNote ?? '',
  });

  const Slider = ({
    label,
    value,
    onChange
  }: {
    label: string;
    value: number;
    onChange: (val: number) => void;
  }) => (
    <div style={{ marginBottom: '16px' }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '6px',
      }}>
        <label style={{ fontSize: '13px', fontWeight: '600', color: '#0f172a' }}>
          {label}
        </label>
        <span style={{ fontSize: '13px', fontWeight: '600', color: '#6B7FFF' }}>
          {value}/5
        </span>
      </div>
      <input
        type="range"
        min="0"
        max="5"
        value={value}
        onChange={(e) => onChange(parseInt(e.target.value))}
        style={{
          width: '100%',
          height: '6px',
          cursor: 'pointer',
          accentColor: '#6B7FFF',
        }}
      />
    </div>
  );

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        padding: '20px',
        paddingTop: '60px',
        overflowY: 'auto',
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'white',
          borderRadius: '20px',
          padding: '24px',
          maxWidth: '500px',
          width: '100%',
          maxHeight: 'calc(100vh - 120px)',
          overflowY: 'auto',
          position: 'relative',
          marginBottom: '40px',
        }}
      >
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          marginBottom: '20px',
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '10px',
            background: 'linear-gradient(135deg, #f0f4ff 0%, #e0e7ff 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <FoodIcon />
          </div>

          <h2 style={{
            fontSize: '20px',
            fontWeight: '700',
            color: '#0f172a',
            margin: 0,
          }}>
            Jedzenie
          </h2>
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '12px',
            borderRadius: '10px',
            border: '2px solid #e2e8f0',
            cursor: 'pointer',
            background: localData.dietChange ? '#f0f4ff' : 'white',
            marginBottom: '8px',
          }}>
            <input
              type="checkbox"
              checked={localData.dietChange}
              onChange={(e) => setLocalData({ ...localData, dietChange: e.target.checked })}
              style={{
                width: '18px',
                height: '18px',
                cursor: 'pointer',
                accentColor: '#6B7FFF',
              }}
            />
            <span style={{
              fontSize: '14px',
              fontWeight: '500',
              color: '#0f172a',
            }}>
              Zmiana względem zwykle
            </span>
          </label>

          {localData.dietChange && (
            <textarea
              value={localData.dietChangeNote}
              onChange={(e) => setLocalData({ ...localData, dietChangeNote: e.target.value })}
              placeholder="Co zmieniłeś w diecie?"
              rows={2}
              style={{
                width: '100%',
                padding: '10px',
                fontSize: '14px',
                borderRadius: '10px',
                border: '2px solid #e2e8f0',
                outline: 'none',
                resize: 'vertical',
                fontFamily: 'inherit',
              }}
            />
          )}
        </div>

        <Slider
          label="Ciężkość posiłków"
          value={localData.mealHeaviness}
          onChange={(v) => setLocalData({ ...localData, mealHeaviness: v })}
        />

        <div style={{ marginBottom: '16px' }}>
          <label style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '12px',
            borderRadius: '10px',
            border: '2px solid #e2e8f0',
            cursor: 'pointer',
            background: localData.alcohol ? '#f0f4ff' : 'white',
            marginBottom: '8px',
          }}>
            <input
              type="checkbox"
              checked={localData.alcohol}
              onChange={(e) => setLocalData({ ...localData, alcohol: e.target.checked })}
              style={{
                width: '18px',
                height: '18px',
                cursor: 'pointer',
                accentColor: '#6B7FFF',
              }}
            />
            <span style={{
              fontSize: '14px',
              fontWeight: '500',
              color: '#0f172a',
            }}>
              Piłeś alkohol?
            </span>
          </label>

          {localData.alcohol && (
            <textarea
              value={localData.alcoholNote}
              onChange={(e) => setLocalData({ ...localData, alcoholNote: e.target.value })}
              placeholder="Co i ile?"
              rows={2}
              style={{
                width: '100%',
                padding: '10px',
                fontSize: '14px',
                borderRadius: '10px',
                border: '2px solid #e2e8f0',
                outline: 'none',
                resize: 'vertical',
                fontFamily: 'inherit',
              }}
            />
          )}
        </div>

        <button
          onClick={() => onSave(localData)}
          style={{
            width: '100%',
            padding: '12px',
            borderRadius: '10px',
            border: 'none',
            background: 'linear-gradient(135deg, #6B7FFF 0%, #5A6EE6 100%)',
            color: 'white',
            fontSize: '15px',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          Gotowe ✓
        </button>
      </div>
    </div>
  );
};
